
export interface IStatusChangeDetails {
    name: string | null,
}

export const statusInitValues: IStatusChangeDetails = {
    name: null,
}
